<div id='scale-{{id}}' class="operation-parent no-text-select selectable-{{!disable_drag}}" cdkDrag
  (mousedown)="mousedown($event)" (click)='toggleSelection($event)' [style.z-index]="zndx"
  (cdkDragMoved)="dragMove($event)" (cdkDragEnded)="dragEnd($event)" (cdkDragStarted)="dragStart($event)">


  @if(hasError){
  <div class="errorWarning">
    <button color='accent' matButton="filled" (click)="clearError()"> <i class="fa fa-exclamation-triangle"></i>
      {{errorStatement}}</button>
  </div>
  }



  <div class="operation-container" [style.background-color]="(hasError) ? 'red' : this.color">

    <div class="black-overlay">


      <div class="cxn-row" cdkDragHandle>
        @for (input of opnode?.inlets ?? []; track input; let i = $index) {
        <div class="input-group">
          <app-inlet [opid]='id' [inletid]='i' [dynamic]='is_dynamic_op' (onInputSelected)="inputSelected($event)"
            (onInputVisibilityChange)="visibilityChange($event)" (onInletChange)="onInletChange($event)"
            (onInletLoaded)="inletLoaded($event)"></app-inlet>
        </div>
        }

      </div>


      <div class="top-row " (dblclick)="onDoubleClick($event)" cdkDragHandle>

        <div class="operation-details">
          <div class="name no-text-select">{{displayname}}</div>
          @if (ss.showComponentIds) {
          <div class="debug-id">ID: {{id}}</div>
          }
        </div>



        <mat-menu #editOptions>


          @if (!hasPin()) {
          <button mat-menu-item (click)="pinToView()">
            <i class="fa-solid fa-map-pin"></i> pin for view
          </button>
          }


          @if (hasPin()) {
          <button mat-menu-item color="accent" (click)="unpinFromView()">
            <i class="fa-solid fa-map-pin"></i> unpin from view
          </button>
          }

          <button mat-menu-item (click)="openInEditor()">
            <i class="fa-solid fa-pen-to-square"></i> open in editor
          </button>

          <button mat-menu-item matTooltip="Duplicate" (click)="duplicate()">
            <i class="fa-solid fa-clone"></i> duplicate
          </button>

          <button mat-menu-item (click)="openHelpDialog()">
            <i class="fa-solid fa-circle-info"></i> help
          </button>

          <button mat-menu-item (click)="saveAsBmp()" matTooltip="Download as Bitmap">
            <i class="fa-solid fa-download"></i> download as bitmap
          </button>

          <button mat-menu-item (click)="saveAsPrint()" matTooltip="Download as Printable Image">
            <i class="fa-solid fa-image"></i> download as image
          </button>

          <button mat-menu-item (click)="saveAsWif()" matTooltip="Download as .WIF file">
            <i class="fa-solid fa-file"></i> download as .WIF file
          </button>

          <button mat-menu-item (click)="delete()">
            <i class="fa-solid fa-times"></i> delete

          </button>





        </mat-menu>

        <button mat-icon-button #trigger [matMenuTriggerFor]="editOptions" class="name is-small fa-solid fa-ellipsis"
          matTooltip="View Options">
        </button>





      </div>

      <div class="params">
        @for (param of op?.params ?? []; track param; let i = $index) {
        @if (param.type !== 'p5-canvas') {
        <app-parameter class="param" [param]='param' [opid]='id' [paramid]='i'
          (onOperationParamChange)=onParamChange($event) (onFileUpload)=handleFile($event)
          (preventDrag)="disableDrag()">
        </app-parameter>
        }
        }
      </div>

      <!-- Canvas Parameters Area -->
      <div class="canvas-params-container">
        @for (param of op?.params ?? []; track param; let i = $index) {
        @if (param.type === 'p5-canvas') {
        <app-parameter class="param-canvas" [param]='param' [opid]='id' [paramid]='i'
          (onOperationParamChange)=onParamChange($event) (onFileUpload)=handleFile($event) (preventDrag)=disableDrag()>
        </app-parameter>
        }
        }
      </div>


      <div class="outputs" (dblclick)="onDoubleClick($event)">

        @for (child_id of children; track child_id) {


        <app-draftcontainer class="draftrendering from_operation" [id]="child_id" [hasParent]="true"
          (click)="toggleSelection($event, child_id)" (connectionSelected)="connectionStarted($event)"
          (onDuplicateCalled)="duplicate()" (onDeleteCalled)="delete()"
          (onDrawdownSizeChanged)="updateOutboundConnections($event)"
          (onDraftVisibilityChanged)="updateOutboundConnections($event)" (onNameChanged)="nameChanged($event)">
        </app-draftcontainer>
        }
      </div>

    </div>
  </div>
</div>